import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";

import "./styles.css";

import { ApiProvider } from "./api/provider";
import { SessionProvider } from "./auth/session";
import { router } from "./router";
import { restoreAppearance } from "./theme";

const root = document.getElementById("root");
if (!root) throw new Error("index.html is missing #root");

restoreAppearance();

/*
 * Provider order is load-bearing. ApiProvider reads the session to get a token
 * and to sign out on a 401, so it has to sit inside SessionProvider — the
 * reverse compiles and then fails at runtime with a context error that points
 * at the wrong file.
 */
createRoot(root).render(
  <StrictMode>
    <SessionProvider>
      <ApiProvider baseUrl="/api">
        <RouterProvider router={router} />
      </ApiProvider>
    </SessionProvider>
  </StrictMode>,
);
